import { render, staticRenderFns } from "./TokenizePayment.vue?vue&type=template&id=6b8c52f8&scoped=true"
import script from "./TokenizePayment.vue?vue&type=script&lang=js"
export * from "./TokenizePayment.vue?vue&type=script&lang=js"
import style0 from "./TokenizePayment.vue?vue&type=style&index=0&id=6b8c52f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c52f8",
  null
  
)

export default component.exports